export const EulaPrivacy: React.FC<{}> = () => {
  return (
    <div
      id="div-application-eula-privacy"
      className="div application-eula-privacy"
    >
      <section className="block block-tight">
        <div className="wrap legal-doc">
          <div className="eyebrow">Legal</div>
          <h3 className="section-head">EULA &amp; Privacy</h3>

          <h4>Apple App Store EULA</h4>
          <p className="eula-body">
            This End-User License Agreement ("EULA") is a legal agreement
            between you and Steamtown Media Limited for the software application
            you have downloaded from the Apple App Store. By downloading or
            using the Application, you agree to be bound by the terms of this
            EULA. If you do not agree to the terms of this EULA, do not download
            or use the Application.
          </p>

          <h4>Privacy Policy</h4>
          <div className="legal-panel">
            <p className="privacy-body">TBD</p>
          </div>

          <div className="legal-links">
            <span className="mono">PER-APP PRIVACY POLICIES</span>
            <a href="/pp3-privacy.html">Pic Perfect 3 privacy policy</a>
            <a href="/dayfocus-privacy.html">DayFocus privacy policy</a>
          </div>
        </div>
      </section>
    </div>
  );
};
